import imageOne from '@/assets/images/cities/etobicoke1.jpg'
import imageTwo from '@/assets/images/cities/etobicoke2.jpg'
import imageThree from '@/assets/images/cities/etobicoke3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Etobicoke',
  writeup: '',
  website: 'EtobicokeNotary.com',
  url: 'https://www.etobicokenotary.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(647) 795-2772',
      hours: {
        monday: '9:00AM to 5:00PM',
        tuesday: '9:00AM to 5:00PM',
        wednesday: '9:00AM to 5:00PM',
        thursday: '9:00AM to 5:00PM',
        friday: '9:00AM to 5:00PM',
        saturday: '',
        sunday: ''
      },
      address: '19 Woodbine Downs Blvd. Location',
      notes: ''
    }
    // }, {
    //   'name': 'Etobicoke South',
    //   'open': true,
    //   'phone': '(647) 796-2772',
    //   'hours': {
    //     'monday': '10:00AM to 6:00PM',
    //     'tuesday': '10:00AM to 6:00PM',
    //     'wednesday': '10:00AM to 6:00PM',
    //     'thursday': '10:00AM to 6:00PM',
    //     'friday': '10:00AM to 6:00PM',
    //     'saturday': '',
    //     'sunday': ''
    //   },
    //   'address': 'Queensway Location',
    //   'notes': ''
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontarioGTA/cities/etobicoke.js